// extracted by mini-css-extract-plugin
export var wrapper = "LeadScoreChart-module--wrapper--8LUT7";
export var pieChart = "LeadScoreChart-module--pie-chart--1e514";